import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { chain } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "@ngx-translate/core";
function positionByPeriod(period) {
    var map = {
        'up_to_2_days': 0,
        'between_3_and_6_days': 1,
        'between_7_and_15_days': 2,
        'more_than_15_days': 3,
    };
    return map[period];
}
var DashboardMaintenancesService = /** @class */ (function () {
    function DashboardMaintenancesService(apollo, translate) {
        this.apollo = apollo;
        this.translate = translate;
    }
    DashboardMaintenancesService.prototype.accountMaintenancesTypes = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesTypes ($where: DashboardInput!) {\n        accountMaintenancesTypes(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesTypes ($where: DashboardInput!) {\n        accountMaintenancesTypes(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesTypes.items)
                            .orderBy('value')
                            .reverse()
                            .value();
                    })];
            });
        });
    };
    DashboardMaintenancesService.prototype.accountMaintenancesSegments = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesSegments ($where: DashboardInput!) {\n        accountMaintenancesSegments(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesSegments ($where: DashboardInput!) {\n        accountMaintenancesSegments(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesSegments.items)
                            .orderBy('value')
                            .reverse()
                            .value();
                    })];
            });
        });
    };
    DashboardMaintenancesService.prototype.accountMaintenancesTopPendingTime = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesTopPendingTime ($where: DashboardInput!) {\n        accountMaintenancesTopPendingTime(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesTopPendingTime ($where: DashboardInput!) {\n        accountMaintenancesTopPendingTime(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesTopPendingTime.items)
                            .orderBy('value')
                            .reverse()
                            .map(function (item) {
                            item.extra.location = { name: item.name };
                            item.name = item.name + " \u2022 " + item.extra.maintenance.number;
                            return item;
                        })
                            .value();
                    })];
            });
        });
    };
    DashboardMaintenancesService.prototype.accountMaintenancesPendingTimeInterval = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesPendingTimeInterval ($where: DashboardInput!) {\n        accountMaintenancesPendingTimeInterval(where: $where) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesPendingTimeInterval ($where: DashboardInput!) {\n        accountMaintenancesPendingTimeInterval(where: $where) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesPendingTimeInterval.items)
                            .orderBy(function (item) { return positionByPeriod(item.name); })
                            .map(function (value) {
                            var key = ("MAINTENANCES_REPORT.OPEN_MAINTENANCE_PER_PERIOD." + value.name).toUpperCase();
                            value.name = _this.translate.instant(key);
                            return value;
                        })
                            .value();
                    })];
            });
        });
    };
    DashboardMaintenancesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardMaintenancesService_Factory() { return new DashboardMaintenancesService(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.TranslateService)); }, token: DashboardMaintenancesService, providedIn: "root" });
    return DashboardMaintenancesService;
}());
export { DashboardMaintenancesService };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
